module.exports = __webpack_public_path__ + "img/ylkt5-1.fdda2c09.jpg";